import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 获取活动模板列表（按游戏筛选）
export const getActivityCraftTemplates = (game = null) => {
  const params = {}
  if (game) {
    params.game = game
  }
  return api.get('/activity-craft-templates', { params })
}

// 获取活动模板树形结构（一级活动+二级商品）
export const getActivityCraftTemplateTree = (game) => {
  return api.get('/activity-craft-templates/tree', { params: { game } })
}

// 根据ID获取活动模板
export const getActivityCraftTemplate = (id) => {
  return api.get(`/activity-craft-templates/${id}`)
}

// 创建活动模板（仅管理员）
export const createActivityCraftTemplate = (data) => {
  return api.post('/activity-craft-templates', data)
}

// 更新活动模板（仅管理员）
export const updateActivityCraftTemplate = (id, data) => {
  return api.put(`/activity-craft-templates/${id}`, data)
}

// 删除活动模板（仅管理员）
export const deleteActivityCraftTemplate = (id) => {
  return api.delete(`/activity-craft-templates/${id}`)
}

// 保存配置的活动制作选择
export const saveConfigActivityCraft = (configId, selections) => {
  return api.post(`/configs/${configId}/activity-craft`, { selections })
}

// 获取配置的活动制作选择
export const getConfigActivityCraft = (configId) => {
  return api.get(`/configs/${configId}/activity-craft`)
}
